// The Domain service's ServiceActivations/Client* endpoints returned a flattened
// ClientServiceSummary (ClientServiceUid / ServiceUid / ServiceName on one object) and now return
// ClientIntegrationSummary, which keeps the activation record and the definition separate:
//   { Integration: { Uid: <ClientIntegrationUid>, ... }, Definition: { Uid: <former ServiceUid>, ... } }
// Flatten the new shape back to the field names the UI reads so consumers don't care which one
// the server returned.  Definition is null when the activated definition isn't published in the
// VSF integration registry — a real state, not an error, so ServiceUid is simply undefined there.

export const mapClientIntegrationSummary = (item) => {
    if (!item || (!item.Integration && !item.Definition))
        return item

    const integration = item.Integration ?? {}
    const definition = item.Definition ?? {}

    return {
        ...item,
        ClientServiceUid: integration.Uid,
        ClientId: integration.ClientId,
        ClientUid: integration.ClientUid,
        ServiceUid: definition.Uid,
        ServiceType: definition.IntegrationType ?? integration.IntegrationType,
        ServiceCode: definition.IntegrationCode ?? integration.IntegrationCode,
        ServiceName: definition.DisplayName,
        Provisioned: integration.Provisioned,
        Created: integration.Created,
    }
}

export const mapClientIntegrationSummaries = (items) => {
    if (!Array.isArray(items))
        return items

    return items.map(mapClientIntegrationSummary)
}
